module.exports = __webpack_public_path__ + "media/V61.3da9bad4.mp4";